export function getProfileRankText(players, profileUsername) {
    const profilePlayer = players.find((player)=>player.username.toLowerCase() == profileUsername.toLowerCase());
    if (profilePlayer == undefined) return '';
    return `${profilePlayer.rank}/${players.length}`;
}
